const PolicyMemberType = {
  RESOURCE: 'resource',
  USER: 'user',
  USER_GROUP: 'user_group',
} as const;
export type PolicyMemberTypeE = typeof PolicyMemberType[keyof typeof PolicyMemberType];

export default PolicyMemberType;
